export const formatTimer = totalSeconds => {
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

export const formatElapsed = totalSeconds => {
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
};

export const getSecondsUntil = dateString => {
  if (!dateString) return null;

  const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(dateString);
  const parsed = new Date(hasTimezone ? dateString : `${dateString}Z`);
  const diff = Math.floor((parsed.getTime() - Date.now()) / 1000);

  if (!Number.isFinite(diff)) return null;

  return Math.max(0, diff);
};

export const resolveTimerSeconds = (expiresAt, fallbackSeconds) => {
  const seconds = getSecondsUntil(expiresAt);
  return seconds == null ? fallbackSeconds : seconds;
};

export const sanitizePaymentAmountInput = value => {
  const next = String(value).replace(',', '.').replace(/[^\d.]/g, '');
  const dotIndex = next.indexOf('.');
  if (dotIndex === -1) return next;
  return `${next.slice(0, dotIndex + 1)}${next.slice(dotIndex + 1).replace(/\./g, '')}`;
};
